

import React from "react";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import "./DashboardFormBlockModal.css"
import Dropdown from "/src/components/UI/DropDown/DropDown"
import DashboardFormGrid from "../../grid/DashboardFormGrid/DashboardFormGrid"
import { DashboardBlockTypeDropdown } from "../../../blockType"
const DashboardFormBlockMainSlide = ({ type, grid, setValue, watch, register, block }) => {
    
    var structure = type == "update" && block.type == 1 ? JSON.parse(grid.structure) : []
    return (
        <>
            <div className={watch("type") == 1 ? "title_container_grid" : "title_container"} style={{ marginTop: watch("type") == 1 ? "43px !important" : "" }}>
                <Field label="Title" listLabelClassName="field-modal" />
                <TextInput {...register('name', { required: true, minLength: 3 })} placeholder="Enter your block's title" className="input_dashboard_block_form" ></TextInput>
            </div>
            {
                type == "create" &&
                <div className={"dropdown_grid_slide_container title_container dropdown_dashboard_form_block_container"} style={{ gap: watch("type") == 0 ? "44%" : "10%", marginLeft: watch("type") == 0 ? "0px" : "" }}>
                    <Field label="Type" listLabelClassName="field-modal"></Field>
                    <div>
                        <Dropdown {...register('type', { valueAsNumber: true })} setValue={setValue} choices={DashboardBlockTypeDropdown} width="165px" defaultChoice={block?.type}></Dropdown>
                    </div>
                </div>
            }

            {
                watch("type") == 0 &&
                <>
                    <br /><br />
                </>

            }
            {
                watch('type') == 1 &&
                <>
                    <div className="dashboard_grid_container title_container">
                        <div>
                            <Field label="Grid configuration" listLabelClassName="field-modal" />
                            { /* <Tooltip classNameContainer={"top"} classNameBoxText="tooltip_upper" text={"You have to put value like : Orange|Banana|Tomato separate with pipes |"}></Tooltip> */}
                            <DashboardFormGrid _cells={structure} setGrid={(cells) => setValue("structure", cells)} data={block?.grid}></DashboardFormGrid>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
export default DashboardFormBlockMainSlide;